import * as React from 'preact/compat'
import styles from '../../../css/search-panel.pcss.json'
import SVG from '../SVG'
import { type ISeriesSchemeState, SeriesSchemeState } from './state'
import { useCallback, useEffect } from 'preact/compat'
import { loadStylesheet, showModal } from '../../common/helpers'
import GameStatusDialog from '../GameStatusDialog'

const statusIcons = {
  0: 'wishlist',
  1: 'playing',
  2: 'beaten',
  3: 'sleep'
}

export default ({ status, id }: {
  status: number,
  id: number
}) => {
  const context = React.useContext<ISeriesSchemeState>(SeriesSchemeState)

  useEffect(() => {
    loadStylesheet('search-panel')
  })

  let toLibraryOptions: React.JSX.HTMLAttributes<HTMLButtonElement> & {
    'data-plugins'?: string
  } = {
    className: styles['game-card__status-button'],
    'data-plugins': 'auth'
  }

  if (context.isLoggedIn.value) {
    const showStatusDialog = useCallback((e: React.TargetedEvent<HTMLButtonElement>) => {
      e.preventDefault()
      showModal(GameStatusDialog, {
        gameId: `${id}`,
        iconSet: 'colorable',
        element: e.currentTarget
      })
    }, [id])

    toLibraryOptions = {
      className: styles['game-card__status-button'],
      onClick: showStatusDialog
    }
  }

  let statusButton = <button
    type='button'
    {...toLibraryOptions}
  >
    <div data-game-watch-icon={true}>
      <SVG i='sg-new/plus' adaptive />
    </div>
  </button>

  if (status > -1) {
    statusButton = <button
      type='button'
      {...toLibraryOptions}
    >
      <SVG
        i={`game-status/colorable/${statusIcons[status]}`}
        data-game-watch-icon={true}
        data-game-watch-icon-status={statusIcons[status]}
      />
    </button>
  }

  return statusButton
}
